import { useSelector } from 'react-redux'

import { selectInternalStatusBanners } from 'redux/selectors/internal/StatusBanner'

export const useInternalStatusBanners = () => {
  return useSelector(selectInternalStatusBanners)
}
